export function isNumeric(value) {
	return !Number.isNaN(Number(value));
}

export function randomRange(min, max) {
	return Math.floor(min + Math.random() * (max - min));
}

export function formatMoney(value) {
	if (isNaN(value)) return '0,00';
	return Number(value)
		.toFixed(2)
		.replace('.', ',')
		.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function parseMoney(value) {
	if (!value) return 0;
	return Number(value.replace('R$', '').replaceAll('.', '').replace(',', '.'));
}

export function clamp(value, min, max) {
	return Math.max(Math.min(value, max), min);
}

export function formatNumber(value) {
	if (isNaN(value)) return '0';
	return Number(value)
		.toFixed(0)
		.replace('.', ',')
		.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}